import { useEffect, useState } from "react";
import { VehicleService } from "../../../core/services/VehicleService";
import { Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useFormatDate } from "../../../core/hooks/useFormatDate";
import TableFooter from "../../../components/TableFooter";

interface GeofencesProps {
    vehicleId?: number
}

const Geofences: React.FC<GeofencesProps> = ({ vehicleId }) => {
    const { t } = useTranslation();
    const [geofences, setGeofences] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(15); // Number of items per page
    const { validateDateFormatAndTime } = useFormatDate();

    async function loadGeofences() {
        if (vehicleId) {
            const result = await VehicleService.loadGeofenceSecurityRule(vehicleId);
            setGeofences(result.data.geofences);
        }
    }

    useEffect(() => {
        loadGeofences();
    }, [vehicleId]);

    // Calculate the paginated data
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentGeofences = geofences.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(geofences.length / itemsPerPage);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    return (
        <Row className="m-3">
            <h6>{t("vehicles.hardware.geofences.title")}</h6>
            <Table responsive className="mt-4">
                <thead>
                    <tr>
                        <th>{t("vehicles.hardware.geofences.name")}</th>
                        <th>{t("vehicles.hardware.geofences.type")}</th>
                        <th>{t("vehicles.hardware.geofences.registration_date")}</th>
                        <th>{t("vehicles.hardware.geofences.embark_date")}</th>
                    </tr>
                </thead>
                <tbody>
                    {currentGeofences.map((geofence: any, index: number) => (
                        <tr key={index}>
                            <td>{geofence.name}</td>
                            <td>{geofence.type}</td>
                            <td>{validateDateFormatAndTime(geofence.association_date)}</td>
                            <td>{geofence.embarked_date ? validateDateFormatAndTime(geofence.embarked_date) : '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <TableFooter
                    hiddenAction={true}
                    paginate={{
                        current_page: currentPage,
                        qtd: totalPages,
                        onSelectPage: handlePageChange,
                    }}
                />
        </Row>
    );
};

export default Geofences;